import React from "react";
import IMAGES from "../../../constants/images";
import Divider from "../../Common/Divider";
import { redirectToExternalURL } from "../../../utils/helpers";
import {
  Wrapper,
  JoinOurCommunityContainer,
  Title,
  HighlightedText,
  SocialButtonsContainer,
  SocialButton,
  SocialIcon,
  SocialText
} from "./JoinOurCommunityElements";

const socials = [
  {
    platform: "x",
    label: "Stay updated through X",
    icon: IMAGES.joinOurCommunity.x,
    url: "https://x.com/CswapDEX"
  }, {
    platform: "discord",
    label: "Let's chat on Discord",
    icon: IMAGES.joinOurCommunity.discord,
    url: "https://discord.com/invite/DZxfjyHbY4"
  }, {
    platform: "telegram",
    label: "Join our Telegram",
    icon: IMAGES.joinOurCommunity.telegram,
    url: "https://t.me/CswapDEX"
  }, {
    platform: "medium",
    label: "Read our Medium articles",
    icon: IMAGES.joinOurCommunity.medium,
    url: "https://medium.com/@cswapdex"
  }, {
    platform: "github",
    label: "Explore our Code",
    icon: IMAGES.joinOurCommunity.github,
    url: "https://github.com/cswapsystems"
  }, {
    platform: "linkedin",
    label: "Connect via LinkedIn",
    icon: IMAGES.joinOurCommunity.linkedin,
    url: "https://au.linkedin.com/company/cswap-systems-cardano"
  }
]

const JoinOurCommunity = () => {
  return (
    <Wrapper id="socials">
      <Divider />

      <JoinOurCommunityContainer>
        <Title>
          Join our <HighlightedText>Community</HighlightedText>
        </Title>

        <SocialButtonsContainer>
          {socials.map((social) => (
            <SocialButton
              key={social.platform}
              onClick={() => redirectToExternalURL(social.url)}
            >
              <SocialIcon
                src={social.icon}
                alt={social.label}
              />

              <SocialText>{social.label}</SocialText>
            </SocialButton>
          ))}
        </SocialButtonsContainer>
      </JoinOurCommunityContainer>

      <Divider />
    </Wrapper>
  );
};

export default JoinOurCommunity;
